var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.documents.length > 0
        ? _c(
            "el-table",
            {
              staticClass: "b-1 br rb-doc-listing",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.documents,
                stripe: "",
                cellClassName: _vm.colorStep,
                rowKey: _vm.rowKey,
                expandRowKeys: _vm.expandRows
              },
              on: { "expand-change": _vm.loadDocRelateds }
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.hasDeadlines
                            ? _c("rb-deadline-listing", {
                                attrs: {
                                  document: _vm.extractDoc(scope.row),
                                  payments: scope.row.payments,
                                  deadlines: scope.row.deadlines
                                }
                              })
                            : _c("rb-payment-listing", {
                                attrs: {
                                  document: _vm.extractDoc(scope.row),
                                  payments: scope.row.payments
                                }
                              })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1776539673
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "thirdname",
                  label: _vm.$t.__("common.labels.name"),
                  width: "180"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t.__("common.labels.document_number"),
                  width: "180"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              attrs: { href: scope.row.link, target: "_blank" }
                            },
                            [_vm._v(_vm._s(scope.row.ident))]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2112715230
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t.__("common.labels.date") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$filters.saasDateFormatted(
                                  scope.row.displayedDate
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  396714952
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "displayedStep",
                  label: _vm.$t.__(
                    "bankreconciliation.DocumentListing.document_status"
                  )
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            scope.row.displayedStep.name,
                            _vm._b(
                              {
                                key: scope.row.displayedStep.params.id,
                                tag: "component"
                              },
                              "component",
                              scope.row.displayedStep.params,
                              false
                            )
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4177514856
                )
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t.__("common.labels.amount_including_tax")
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(scope.row.formattedTotalAmount) +
                              "\n            "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3445182277
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }